"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { MapPin, Phone, Mail, Languages } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function ContactDetails() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const contactItems = [{
    icon: MapPin,
    label: "Address",
    value: "Dubai, United Arab Emirates",
    href: null
  }, {
    icon: Phone,
    label: "Phone",
    value: "+971 4 123 4567",
    href: "tel:+97141234567"
  }, {
    icon: Mail,
    label: "Email",
    value: "contact@salemballamaauditing.ae",
    href: "mailto:contact@salemballamaauditing.ae"
  }, {
    icon: Languages,
    label: "Bilingual Support",
    value: "Full English and Arabic services available",
    href: null
  }];
  return;
}